import React from 'react';
import TopAreaVariant from './TopAreaVariant';
import { StyledTopAreaVariants } from './TopAreaVariants.styles';

const TopAreaVariants = ({ variants, onClick }) => {
    if (!variants || variants.length === 0) {
        return null;
    }

    // "default" should be the last value in the array
    const sortedVariants = variants.sort((a, b) => (a.accessibility > b.accessibility ? 1 : -1));

    return (
        <StyledTopAreaVariants>
            Finns även{' '}
            {sortedVariants.map((variant, i) => {
                return <TopAreaVariant key={`variant-${i}`} index={i} variant={variant} onClick={onClick} />;
            })}
        </StyledTopAreaVariants>
    );
};

export default TopAreaVariants;
